import { IT } from '@/constants/infrastruktur/assetgruppe.type';
import gruppeApi from '@/services/api/v1/standard/gruppe';
import infrastrukturGruppeApi from '@/services/api/v1/infrastruktur/gruppe';

export default [
  {
    path: 'ressources',
    component: () => import('@/layouts/ressources/RessourcesLayout.vue'),
    children: [
      {
        name: 'ressources',
        path: '',
        component: () => import('@/views/ressources/RessourcenManagementStartseite.vue'),
      },
      {
        path: 'standards',
        component: () => import('@/layouts/ressources/standards/StandardsLayout.vue'),
        children: [
          {
            name: 'standardsliste',
            path: 'list',
            component: () => import('@/views/ressources/standards/StandardListPage.vue'),
            props: {
              canAdd: true,
            },
          },
          {
            name: 'standardsliste.kategorie',
            path: 'list/kategorie/:kategorie',
            component: () => import('@/views/ressources/standards/StandardListPage.vue'),
            props: (route) => ({
              canAdd: true,
              kategorie: route.params.kategorie,
            }),
          },
          {
            name: 'standardsliste.kategorie.status',
            path: 'list/kategorie/:kategorie/status/:status',
            component: () => import('@/views/ressources/standards/StandardListPage.vue'),
            props: (route) => ({
              canAdd: false,
              kategorie: route.params.kategorie,
              status: route.params.status,
            }),
          },
          {
            name: 'standard.neu',
            path: 'standard/neu',
            component: () => import('@/views/ressources/standards/StandardPage.vue'),
            props: (route) => ({
              id: null,
              edit: true,
              query: route.query,
            }),
          },
          {
            name: 'standard.id',
            path: 'standard/:id',
            component: () => import('@/views/ressources/standards/StandardPage.vue'),
            props: (route) => ({
              id: route.params.id,
              edit: false,
            }),
          },
          {
            name: 'standard.id.edit',
            path: 'standard/:id/edit',
            component: () => import('@/views/ressources/standards/StandardPage.vue'),
            props: (route) => ({
              id: route.params.id,
              edit: true,
            }),
          },
          {
            name: 'standard.id.tab',
            path: 'standard/:id/:tab',
            component: () => import('@/views/ressources/standards/StandardPage.vue'),
            props: (route) => ({
              id: route.params.id,
              edit: false,
              tab: route.params.tab,
            }),
          },
          {
            name: 'standard.id.edit.tab',
            path: 'standard/:id/:tab/edit',
            component: () => import('@/views/ressources/standards/StandardPage.vue'),
            props: (route) => ({
              id: route.params.id,
              edit: true,
              tab: route.params.tab,
            }),
          },
          {
            path: 'settings',
            component: () => import('@/layouts/ressources/standards/Settings.vue'),
            children: [
              {
                path: 'normgruppen',
                name: 'standards.settings.normgruppen',
                component: () => import('@/views/ressources/standards/settings/Kategorien.vue'),
                props: {
                  title: 'Norm-Kategorien',
                  api: gruppeApi,
                  name: 'Norm-Kategorie',
                  moduleScope: 'administrative_rights',
                  nameMitArtikel: 'die Norm-Kategorie',
                  allowEditRootLevel: true,
                },
              },
              {
                path: 'kategorien',
                name: 'standards.it.settings.kategorien',
                component: () => import('@/views/infrastrukturverwaltung/settings/Kategorien.vue'),
                props: () => ({
                  title: 'IT-Kategorien',
                  api: infrastrukturGruppeApi,
                  name: 'IT-Kategorie',
                  moduleScope: 'administrative_rights',
                  nameMitArtikel: 'die IT-Kategorie',
                  allowEditRootLevel: false,
                  id: IT, // Pass the ID as a prop to the component
                  excludeIds: [], // Pass excludeIds as an array if provided in query params
                }),
              },
            ],
          },
        ],
      },
    ],
  },
];
